import { styled } from '@mui/material'

export const EmptyStateContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(3),
  flexDirection: 'column',
  height: '60vh',
  [theme.breakpoints.up('md')]: {
    gridColumn: 'span 2',
  },
}))
